import React from 'react'
import { NavLink } from 'react-router-dom'
import MenuGuideButton from '../../components/MenuGuideButton'

function tabClass(isActive) {
  return [
    'rounded-md border px-3 py-2 text-sm font-medium transition-colors',
    isActive ? 'border-brand-navy bg-sky-50 text-brand-navy shadow-sm ring-1 ring-brand-navy/10' : 'border-transparent text-slate-600 hover:bg-slate-100 hover:text-slate-900',
  ].join(' ')
}

/**
 * 설계지원 참고 DB 공통 레이아웃(개요 · 질병·특약 · 수술·종 · 데이터 적재).
 * 데이터는 CSV 적재 후 동일 API로 바로 반영됩니다.
 */
export default function DesignSupportLayout({ children }) {
  return (
    <div className="min-h-[calc(100vh-8rem)] bg-slate-50/80">
      <div className="border-b border-slate-200 bg-white shadow-sm">
        <div className="px-4 py-4 md:px-6">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">설계지원</p>
              <div className="mt-0.5 flex items-center gap-2">
                <h1 className="text-lg font-semibold text-slate-900 sm:text-xl">질병코드 · 특약 · 수술(종) 참고</h1>
                <MenuGuideButton slug="design-support-db" title="설계지원 DB 가이드" />
              </div>
            </div>
            <nav className="flex flex-wrap gap-1.5" aria-label="설계지원 하위 메뉴">
              <NavLink to="/design" end className={({ isActive }) => tabClass(isActive)}>
                개요
              </NavLink>
              <NavLink to="/design/disease-code" className={({ isActive }) => tabClass(isActive)}>
                질병코드 · 특약
              </NavLink>
              <NavLink to="/design/surgery-search" className={({ isActive }) => tabClass(isActive)}>
                수술명 · 종
              </NavLink>
              <NavLink to="/design/major-disease-n" className={({ isActive }) => tabClass(isActive)}>
                N대 질병
              </NavLink>
              <NavLink to="/data/design-support-reference" className={({ isActive }) => tabClass(isActive)}>
                데이터 적재
              </NavLink>
            </nav>
          </div>
        </div>
      </div>

      <div className="px-4 py-6 md:px-6">{children}</div>
    </div>
  )
}
